import { useState, useEffect } from 'react';
import OnboardingFlow from './components/layout/OnboardingFlow';
import { OnboardingProvider } from './context/OnboardingContext';
import { initAmplitude } from './services/analytics';
import { initRinoAnalytics } from './services/rinoAnalytics';
import './utils/currency';

function App() {

    console.log("App init");

    useEffect(() => {
        initAmplitude();
        initRinoAnalytics('rino-funnels-v2');
    }, []);

    return (
        <OnboardingProvider>
            <div id="onboarding-container">
                <OnboardingFlow />
            </div>
        </OnboardingProvider>
    );
}

export default App;

